import styled from 'styled-components';

export const CardContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  position: relative;
  padding: 15px 0;
  border-bottom: 0.5px solid #8b8b8b;

  &.last {
    margin-bottom: 24px;
  }

  .flex-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
`;

export const Date = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 4px;
`;

export const Bookmark = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  box-shadow: 1px 1px 12px 0px rgba(50, 50, 50, 0.2);
  z-index: 2;
  cursor: pointer;
  padding: 8px;
  width: 36px;
  height: 36px;
  border-radius: 100%;
  display: flex;

  & svg {
    stroke: ${(props) => props.theme.colors.link};
  }
`;

export const Body = styled.div`
  max-width: 100%;

  h3 {
    max-width: calc(100% - 40px);
  }

  p {
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const FileImg = styled.img`
  width: 20px;
  height: auto;
  margin-top: 6px;
`;

export const Bottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 8px;

  .size {
    margin-right: auto;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: end;
  gap: 11px;

  &:hover {
    text-decoration: underline;
  }

  div {
    color: ${({ theme }) => theme.colors.themeColor};
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
  }
  svg {
    stroke: ${({ theme }) => theme.colors.title};
  }
`;
